import {DotFillIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {useState} from 'react'

import styles from './TriageAgentButton.module.css'
import {TriageAgentDialog} from './TriageAgentDialog'
import {useTriageAgentStatus} from './use-triage-agent-status'

type TriageAgentButtonProps = {
  repoOwner: string
  repoName: string
}

export function TriageAgentButton({repoOwner, repoName}: TriageAgentButtonProps) {
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const {data, isLoading, isError} = useTriageAgentStatus(repoOwner, repoName)

  const isActive = data?.enabled && data?.config_exists

  const getIndicatorColor = () => {
    if (isError) return 'var(--fgColor-attention)'
    if (isActive) return 'var(--fgColor-success)'
    return 'var(--fgColor-muted)'
  }

  const getIndicatorTestId = () => {
    if (isError) return 'triage-agent-status-error'
    if (isActive) return 'triage-agent-status-active'
    return 'triage-agent-status-inactive'
  }

  const getIndicatorAriaLabel = () => {
    if (isError) return 'Error loading triage agent status'
    if (isActive) return 'Triage agent is active'
    return 'Triage agent is inactive'
  }

  const renderLeadingVisual = () => (
    <span className="d-flex flex-items-center gap-1">
      {!isLoading && (
        <span
          data-testid={getIndicatorTestId()}
          className={`${styles.statusIndicator} ${isActive ? styles.pulse : ''}`}
          style={{color: getIndicatorColor()}}
        >
          <DotFillIcon size={12} aria-label={getIndicatorAriaLabel()} />
        </span>
      )}
    </span>
  )

  return (
    <>
      <Button leadingVisual={renderLeadingVisual} onClick={() => setIsDialogOpen(true)}>
        Triage agent
      </Button>
      {isDialogOpen && (
        <TriageAgentDialog repoOwner={repoOwner} repoName={repoName} onClose={() => setIsDialogOpen(false)} />
      )}
    </>
  )
}

try{ TriageAgentButton.displayName ||= 'TriageAgentButton' } catch {}